import { AccessesWithTerminationDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ApproverWithBadge } from 'modules/approvals/components/ApproverWithBadge'
import type { ApproverArgs } from 'modules/approvals/lib/approvalFlows'
import { roleInitials, roleName } from 'modules/approvals/lib/roles'

interface Props {
  approver: ApproverArgs
}

export const StepApprover = ({ approver }: Props) => {
  const { data } = useQuery(AccessesWithTerminationDocument, {
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    variables: { ids: [approver.accessId!] },
    skip: !approver.accessId,
  })

  const access = data?.apiCore.accessesConnection.nodes[0]

  const accessToApprove = approver.strategy === 'members' ? access : null

  return (
    <ApproverWithBadge
      accessToApprove={accessToApprove}
      role={roleName(approver.strategy)}
      roleInitials={roleInitials(approver.strategy)}
    />
  )
}
